<!-- Inside .modal-content -->
<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content modal-content">
    <div class="sticky-top">
      <ion-buttons slot="end" class="ion-no-margin">
        <ion-button class="header-button-cancel unfilled-gray-btn" (click)="closeModal()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <h2 class="main-heading">
        Join TripMeld CRM in just 4 simple steps and streamline your travel business
      </h2>
      <p class="px-4" style="font-size: 14px;" *ngIf="!isTrailUser">You are currently subscribed to the
        <b>{{existingPackageDetails?.packageName}}</b>. To upgrade or change your subscription plan, please contact
        Tripmeld at <b>+91 928 111 7175</b> or email us at <b>{{"contact@tripmeld.com"}}</b> or
        <b>{{"support@tripmeld.com"}}</b> — we're here to help you make the most of your experience.</p>
      <div class="step-tracker" *ngIf="isTrailUser">
        <div class="step-item" [class.active]="currentStep >= 1">
          <div class="step-circle">
            <ion-icon name="airplane-outline"></ion-icon>
          </div>
          <div class="step-label">Plan</div>
        </div>

        <div class="step-line"></div>

        <div class="step-item" [class.active]="currentStep >= 2">
          <div class="step-circle">
            <ion-icon name="airplane-outline"></ion-icon>
          </div>
          <div class="step-label">Add User</div>
        </div>

        <div class="step-line"></div>

        <div class="step-item" [class.active]="currentStep >= 3">
          <div class="step-circle">
            <ion-icon name="airplane-outline"></ion-icon>
          </div>
          <div class="step-label">Pay</div>
        </div>

        <div class="step-line"></div>

        <div class="step-item" [class.active]="currentStep >= 4">
          <div class="step-circle">
            <ion-icon name="airplane-outline"></ion-icon>
          </div>
          <div class="step-label">Confirmation</div>
        </div>
      </div>
    </div>

    <!-- close button -->
    <div class="back-arrow-container" *ngIf="currentStep > 1 && currentStep < 4">
      <ion-button fill="clear" class="back-arrow-btn" (click)="goBack()">
        <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
        <span>Back</span>
      </ion-button>
    </div>

    <div class="child-container">
      <app-packages-details *ngIf="currentStep === 1" 
      [selectedPackage]="selectedPackageData"
      (submitPlanData)="handlePackageSubmit($event)" 
      [isTrailUser]="isTrailUser">
      </app-packages-details>

      <app-adduser-cost *ngIf="currentStep === 2" 
      [selectedPackage]="selectedPackageData"
      [saveUsersAndCostData]="usersAndCostData" 
      (saveAmountData)="saveAmountData($event)"
      (storePayment)="updateBillingDetails($event)"
      (proceed)="handleProceedFromAddUser()">
      </app-adduser-cost>

      <app-payment-details *ngIf="currentStep === 3" 
      [selectedPackage]="selectedPackageData"
      [storedFormData]="billingDetails"
      (saveBillingData)="saveBillingData($event)"
      (storePayment)="updateBillingDetails($event)"
      [usersAndCostData]="usersAndCostData" 
      (paymentCompleted)="handlePaymentComplete()">
      </app-payment-details>

      <app-confirmation *ngIf="currentStep === 4" 
      [txnId]="txnId"
      (confirm)="handleFinishStep()">
      </app-confirmation>
    </div>
  </div>
</div>